import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Search, Plus, Loader2 } from 'lucide-react';

const GlobalSearchSection = ({
  globalSearchMode,
  setGlobalSearchMode,
  globalSearchQuery,
  setGlobalSearchQuery,
  globalSearchResults,
  globalSearchLoading,
  addFromGlobalSearch,
  language
}) => {
  return (
    <Card className={`transition-all ${globalSearchMode ? 'ring-2 ring-cyan-500 bg-cyan-50/50' : ''}`}>
      <CardContent className="p-4">
        <div className="flex items-center gap-4">
          <Button
            variant={globalSearchMode ? "default" : "outline"}
            onClick={() => {
              setGlobalSearchMode(!globalSearchMode);
              if (!globalSearchMode) {
                setGlobalSearchQuery('');
              }
            }}
            className={globalSearchMode ? "bg-cyan-600 hover:bg-cyan-700" : ""}
            data-testid="global-search-toggle"
          >
            <Search className="w-4 h-4 mr-2" />
            {language === 'fr' ? 'Recherche globale' : 'Global Search'}
          </Button>
          
          {globalSearchMode && (
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input
                placeholder={language === 'fr' 
                  ? "Rechercher dans tout le catalogue (cosmétiques, compléments, divers)..." 
                  : "Search all catalog (cosmetics, supplements, other)..."}
                value={globalSearchQuery}
                onChange={(e) => setGlobalSearchQuery(e.target.value)}
                className="pl-10 bg-white"
                autoFocus
                data-testid="global-search-input"
              />
              {globalSearchLoading && (
                <Loader2 className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 animate-spin text-cyan-500" />
              )}
            </div>
          )}
        </div>
        
        {/* Global Search Results */}
        {globalSearchMode && globalSearchResults.length > 0 && (
          <div className="mt-4 border rounded-lg divide-y max-h-96 overflow-y-auto">
            {globalSearchResults.map((item, index) => (
              <div 
                key={`${item.id || item.item_id}-${index}`}
                className="flex items-center justify-between p-3 hover:bg-gray-50"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-sm">{item.name}</span>
                    <Badge 
                      variant="outline" 
                      className={
                        item.resultCategory === 'cosmetics' ? 'bg-blue-50 text-blue-700 border-blue-200' :
                        item.resultCategory === 'supplements' ? 'bg-green-50 text-green-700 border-green-200' :
                        'bg-purple-50 text-purple-700 border-purple-200'
                      }
                    >
                      {item.categoryLabel}
                    </Badge>
                  </div>
                  <p className="text-sm text-gray-600">{item.price?.toLocaleString('fr-FR')} FCFA</p>
                </div>
                <Button
                  size="sm"
                  onClick={() => addFromGlobalSearch(item)}
                  className="bg-cyan-600 hover:bg-cyan-700"
                  data-testid={`global-add-${item.id || item.item_id}`}
                >
                  <Plus className="w-4 h-4 mr-1" />
                  {language === 'fr' ? 'Ajouter' : 'Add'}
                </Button>
              </div>
            ))}
          </div>
        )}
        
        {globalSearchMode && globalSearchQuery && globalSearchQuery.length >= 2 && globalSearchResults.length === 0 && !globalSearchLoading && (
          <p className="mt-4 text-center text-gray-500">
            {language === 'fr' ? 'Aucun produit trouvé' : 'No products found'}
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default GlobalSearchSection;
